import PatientList from "./PatientList";
import PendingList from "./PendingList";
const PatientListTab = () => {
  return (
    <div>
     <PendingList/>
     <PatientList/>
    </div>
  );
};

export default PatientListTab;
